import { objToQs } from '../Utils';

import Call from '../Call';

const Conversions = {
    getPage(page, filters = {}, sort) {
        const params = Object.assign({}, filters);

        if(params.countries && params.countries.length) params.countries = JSON.stringify(params.countries);
        if(sort) params.sort = JSON.stringify(sort);

        return Call(`conversions/${page}?${objToQs(params)}`);
    },
}

export default Conversions;


// WEBPACK FOOTER //
// ./src/services/API/components/Conversions.js